import {GooglePlace} from "../../types/googlePlace.type";
import {IsBeforeDate} from "../../validators/isBeforeDate.validator";
import moment from "moment/moment";
import {IsNotEmpty} from "class-validator";

class StarSignQuizModel {
    @IsBeforeDate(moment().subtract(13, 'years').toDate(), {message: "You must be over 13 years to make an account"})
    @IsNotEmpty({message: "Please enter your date of birth"})
    dateOfBirth: Date;
    @IsNotEmpty({message: "Please enter what city were you born in"})
    birthPlace: GooglePlace;
    timeOfBirthHour: number;
    timeOfBirthMinute: number;
    timeOfBirthPeriod: "AM" | "PM";
}

export {StarSignQuizModel}